module.exports = __webpack_public_path__ + "assets/imgs/gmp/gmp-studio.6da5343517f9c5d2041458ca2afabda1.png";